class TabbedCollections extends HTMLElement {
  constructor() {
    super();

    this.tabs = Array.from(this.querySelectorAll('[data-tabbed-collections-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-tabbed-collections-panel]'));
    this.productLists = Array.from(this.querySelectorAll('[data-tabbed-collections-slider]'));
    this.previousButtons = Array.from(this.querySelectorAll('[data-tabbed-collections-previous]'));
    this.nextButtons = Array.from(this.querySelectorAll('[data-tabbed-collections-next]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
      tab.addEventListener('keydown', this.onTabKeydown.bind(this));
    });

    this.productLists.forEach((productList) => {
      initCarouselScroll(productList, {
        draggingClass: 'tabbed-collections__product-list--dragging',
        onScroll: this.updateArrows.bind(this),
      });
    });

    this.previousButtons.forEach((button) => {
      button.addEventListener('click', this.onArrowClick.bind(this, 'previous'));
    });

    this.nextButtons.forEach((button) => {
      button.addEventListener('click', this.onArrowClick.bind(this, 'next'));
    });

    this.updateArrows();
  }

  onTabClick(event) {
    this.activateTab(event.currentTarget);
  }

  onTabKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = currentIndex + 1 >= this.tabs.length ? 0 : currentIndex + 1;
    }
    else if (event.key === 'ArrowLeft') {
      nextIndex = currentIndex - 1 < 0 ? this.tabs.length - 1 : currentIndex - 1;
    }
    else if (event.key === 'Home') {
      nextIndex = 0;
    }
    else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    }
    else {
      return;
    }

    event.preventDefault();
    this.activateTab(this.tabs[nextIndex], true);
  }

  activateTab(activeTab, focusTab = false) {
    const activePanelId = activeTab.getAttribute('aria-controls');

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;

      tab.classList.toggle('tabbed-collections__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === activePanelId;

      panel.classList.toggle('tabbed-collections__panel--active', isActive);
      panel.hidden = !isActive;

      if (isActive) {
        const productList = panel.querySelector('.tabbed-collections__product-list');

        if (productList) {
          productList.scrollLeft = 0;
        }
      }
    });

    this.updateArrows();

    if (focusTab) {
      activeTab.focus();
    }
  }

  onArrowClick(direction, event) {
    const panel = event.currentTarget.closest('[data-tabbed-collections-panel]');
    const slider = panel ? panel.querySelector('[data-tabbed-collections-slider]') : null;

    if (!slider) {
      return;
    }

    const item = slider.querySelector('.tabbed-collections__product-item');
    const gap = parseFloat(window.getComputedStyle(slider).columnGap) || 0;
    const scrollAmount = item ? item.getBoundingClientRect().width + gap : slider.clientWidth;

    slider.scrollBy({
      left: direction === 'next' ? scrollAmount : -scrollAmount,
      behavior: 'smooth',
    });

    window.setTimeout(() => this.updateArrows(), 350);
  }

  updateArrows() {
    this.panels.forEach((panel) => {
      const slider = panel.querySelector('[data-tabbed-collections-slider]');
      const previousButton = panel.querySelector('[data-tabbed-collections-previous]');
      const nextButton = panel.querySelector('[data-tabbed-collections-next]');

      if (!slider || !previousButton || !nextButton) {
        return;
      }

      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const isScrollable = maxScroll > 1;
      const sliderWrapper = slider.closest('.tabbed-collections__slider');

      if (sliderWrapper) {
        sliderWrapper.classList.toggle('tabbed-collections__slider--arrows-visible', isScrollable);
      }
      previousButton.hidden = !isScrollable;
      nextButton.hidden = !isScrollable;
      previousButton.disabled = slider.scrollLeft <= 1;
      nextButton.disabled = slider.scrollLeft >= maxScroll - 1;
    });
  }
}

if (!customElements.get('tabbed-collections')) {
  customElements.define('tabbed-collections', TabbedCollections);
}
